export default __webpack_public_path__ + "static/media/miembrosume_registro_bco.f073ce57.png";